<template>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />


      <div class="">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <p
            class="text-center text-sm font-semibold uppercase text-gray-500 tracking-wide"
          >
            <!-- Trusted by -->
          </p>
          <div class="mt-6 grid grid-cols-1 gap-1 md:grid-cols-1">
            <p style="font-weight: bold;">Исполнительный директор</p>
            <p>Фонд поддержки и развития доказательной медицины</p>
            <p>Анциферов Данила Евгеньевич <a style="color: blue;" href="mailto:ade@mmacademy.ru">ade@mmacademy.ru</a> </p>
          </div>
          <div class="mt-6 grid grid-cols-1 gap-1 md:grid-cols-1">
            <p style="font-weight: bold;">Координатор проектов</p>
            <p>Фонд поддержки и развития доказательной медицины</p>
            <p>Сергеева Анастасия Сергеевна <a style="color: blue;" href="mailto:sergeeva@gepatitu.net">sergeeva@gepatitu.net</a> </p>





          </div>

        </div>
      </div>
 



    </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
export default {
    data() {
        return {
            title: 'Контакты'
        }
    },
    components: {
        PageTitle,
    }
}
</script>